import React from 'react';
import { Scale, Shield, FileText, AlertTriangle } from 'lucide-react';
import { SEO } from '../lib/seo';

const TermsOfService: React.FC = () => {
  return (
    <>
      <SEO 
        title="Términos y Condiciones | Electricista Barcelona"
        description="Términos y condiciones del servicio. Información sobre derechos y obligaciones, garantías y política de cancelación."
        canonical="/terms"
        type="website"
      />
      
      <div className="py-16">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl font-bold mb-8">Términos y Condiciones del Servicio</h1>

          <div className="prose max-w-none">
            <section className="mb-12">
              <div className="flex items-center gap-2 mb-4">
                <Scale className="w-6 h-6 text-yellow-500 flex-shrink-0" />
                <h2 className="text-2xl font-bold">Condiciones Generales</h2>
              </div>
              
              <p className="mb-4">
                Los presentes términos y condiciones regulan la prestación de servicios de electricidad por parte de Manel Belmonte Montesinos, con domicilio en Carrer de Trinxant, 128, local derecho, San Andrés de Palomar, 08041 Barcelona.
              </p>

              <h3 className="text-xl font-bold mt-8 mb-4">Servicios Ofrecidos</h3>
              <ul className="list-disc list-inside space-y-2">
                <li>Reparaciones eléctricas de urgencia 24/7</li>
                <li>Instalaciones eléctricas</li>
                <li>Inspecciones de seguridad</li>
                <li>Mantenimiento eléctrico</li>
                <li>Certificados CIE y BRIE</li>
              </ul>
            </section>

            <section className="mb-12">
              <div className="flex items-center gap-2 mb-4">
                <FileText className="w-6 h-6 text-yellow-500 flex-shrink-0" />
                <h2 className="text-2xl font-bold">Presupuestos y Facturación</h2>
              </div>

              <div className="space-y-4">
                <h3 className="text-xl font-bold">Presupuestos</h3>
                <p>
                  Para la realización de presupuestos es necesario una visita técnica previa, con el fin de obtener datos sobre el estado actual de la instalación. Esta visita tiene un coste que se abonará al fin de la misma, tras ésta, se entregará un informe técnico y el presupuesto.
                </p>

                <h3 className="text-xl font-bold">Facturación</h3>
                <p>
                  Se emitirá factura detallada por todos los servicios prestados, incluyendo el desglose de materiales utilizados, horas de trabajo y cualquier otro concepto aplicable.
                </p>

                <h3 className="text-xl font-bold">Formas de Pago</h3>
                <ul className="list-disc list-inside space-y-2">
                  <li>Efectivo</li>
                  <li>Transferencia bancaria</li>
                  <li>Tarjeta de crédito/débito</li>
                  <li>Bizum</li>
                </ul>
              </div>
            </section>

            <section className="mb-12">
              <div className="flex items-center gap-2 mb-4">
                <Shield className="w-6 h-6 text-yellow-500 flex-shrink-0" />
                <h2 className="text-2xl font-bold">Garantías</h2>
              </div>

              <div className="space-y-4">
                <p>
                  Todos nuestros trabajos están garantizados según la normativa vigente:
                </p>
                <ul className="list-disc list-inside space-y-2">
                  <li>Reparaciones: 6 meses de garantía</li>
                  <li>Instalaciones nuevas: 2 años de garantía</li>
                  <li>Materiales: según garantía del fabricante</li>
                </ul>
                <p>
                  La garantía cubre defectos de instalación y materiales, no incluyendo mal uso o manipulación por terceros.
                </p>
              </div>
            </section>

            <section className="mb-12">
              <div className="flex items-center gap-2 mb-4">
                <AlertTriangle className="w-6 h-6 text-yellow-500 flex-shrink-0" />
                <h2 className="text-2xl font-bold">Cancelaciones</h2>
              </div>

              <div className="space-y-4">
                <h3 className="text-xl font-bold">Política de Cancelación</h3>
                <ul className="list-disc list-inside space-y-2">
                  <li>Cancelación con más de 24h de antelación: sin coste</li>
                  <li>Cancelación con menos de 24h: 30% del presupuesto</li>
                  <li>No presentación: 50% del presupuesto</li>
                </ul>

                <div className="bg-yellow-50 p-6 rounded-lg mt-6">
                  <h4 className="font-bold mb-2">Servicios de Urgencia</h4>
                  <p>
                    Para servicios de urgencia 24h, se aplicará un cargo mínimo de desplazamiento en caso de cancelación una vez el técnico esté en camino.
                  </p>
                </div>
              </div>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-bold mb-4">Responsabilidad</h2>
              <p className="mb-4">
                Contamos con seguro de responsabilidad civil profesional que cubre posibles daños durante la ejecución de los trabajos. No nos hacemos responsables de:
              </p>
              <ul className="list-disc list-inside space-y-2">
                <li>Daños causados por instalaciones preexistentes defectuosas</li>
                <li>Problemas derivados de modificaciones realizadas por terceros</li>
                <li>Uso indebido de las instalaciones</li>
                <li>Fuerza mayor o causas ajenas a nuestro control</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">Modificaciones</h2>
              <p>
                Nos reservamos el derecho a modificar estos términos y condiciones en cualquier momento. Los cambios entrarán en vigor desde su publicación en esta página web.
              </p>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export default TermsOfService;